export default {
  navigationBarTitleText: '商家认证信息'
};
